export const GRID_COLUMNS = 12 as const;
